const TEXT_KEYS = [
  "title",
  "description",
  "ogTitle",
  "ogDescription",
  "twitterTitle",
  "twitterDescription",
  "ogSiteName",
];

const IMAGE_KEYS = ["ogImage", "twitterImage", "twitterCard"];

const AI_IMPROVED_KEYS = [...TEXT_KEYS, ...IMAGE_KEYS];

export function mergeSocialTags(baseTags, aiTags) {
  if (!aiTags) return { ...baseTags };
  return { ...baseTags, ...aiTags };
}

export function buildResolvedFromTags(resolved, tags) {
  if (!resolved || !tags) return resolved;
  return {
    ...resolved,
    title:
      tags.twitterTitle ||
      tags.ogTitle ||
      tags.title ||
      resolved.title ||
      "",
    description:
      tags.twitterDescription ||
      tags.ogDescription ||
      tags.description ||
      resolved.description ||
      "",
    image:
      tags.twitterImage ||
      tags.ogImage ||
      resolved.image ||
      "",
  };
}

export function isAiImprovedField(key, baseTags, aiTags) {
  return (
    AI_IMPROVED_KEYS.includes(key) &&
    aiTags?.[key] &&
    aiTags[key] !== (baseTags?.[key] || "")
  );
}
